import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { ImageCropperComponent } from 'ngx-image-cropper';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { KYCVerificationService } from 'src/app/registration/shared/kyc-verification.service';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { EmploymentState } from 'src/app/registration/state/employment.state';
import { RegistrationRouterState } from 'src/app/registration/state/registration-router.state';
import { RegistrationState } from 'src/app/registration/state/registration.state';
import { ResidenceState } from 'src/app/registration/state/residence.state';
import { WebcamSnapshotComponent } from 'src/app/registration/webcam-snapshot/webcam-snapshot.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { DriverApiService } from 'src/app/shared/services/driver-api.service';
import { PhoneMaskDirective } from '../phone-mask/phone-mask.directive';
import { ProfileLicenseInformationComponent } from '../profile/profile-license-information/profile-license-information.component';
import { ProfileModule } from '../profile/profile.module';
import { ActionsModule } from '../shared/actions/actions.module';
import { CompletionMeterModule } from '../shared/completion-meter/completion-meter.module';
import { ComponentsModule } from '../shared/components/components.module';
import { CustomFormValidatorsModule } from '../shared/custom-form-validators/custom-form-validators.module';
import { LoadingGifComponent } from '../shared/loading-gif/loading-gif/loading-gif.component';
import { AccidentRecordsComponent } from './accident-records/accident-records.component';
import { AccidentRecordViewComponent } from './accident-view/accident-view.component';
import { AdditionalDocumentUploadComponent } from './additional-document-upload/additional-document-upload.component';
import { AdditionalDocumentViewComponent } from './additional-document-view/additional-document-view.component';
import { AdditionalDocumentsComponent } from './additional-documents/additional-documents.component';
import { DriveTestComponent } from './drive-test/drive-test.component';
import { DriverProfileDashboardComponent } from './driver-profile-dashboard/driver-profile-dashboard.component';
import { EmploymentFormComponent } from './employment-form/employment-form.component';
import { EmploymentHistoryFormEmployedComponent } from './employment-history/employment-history-form-employed/employment-history-form-employed.component';
import { EmploymentHistoryFormUnemployedComponent } from './employment-history/employment-history-form-unemployed/employment-history-form-unemployed.component';
import { IncorporationComponent } from './incorporation/incorporation.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { MedicalExaminationComponent } from './medical-examination/medical-examination.component';
import { OnDutyHourComponent } from './on-duty-hour/on-duty-hour.component';
import { PersonalInformationNewComponent } from './personal-information-new/personal-information-new.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { ProfilePictureComponent } from './profile-picture/profile-picture.component';
import { RegistrationComponent } from './registration/registration.component';
import { RequirementsCompleteActionComponent } from './requirements-complete-action/requirements-complete-action.component';
import { ResidenceHistoryFormComponent } from './residence-history/residence-history-form/residence-history-form.component';
import { ResidenceHistoryComponent } from './residence-history/residence-history.component';
import { ResumeComponent } from './resume/resume.component';
import { TrafficConvictionsComponent } from './traffic-convictions/traffic-convictions.component';

import { SharedModule } from '../shared/shared.module';
import { DriverTrainingCertificatesComponent } from './driver-training-certificates/driver-training-certificates.component';
import { VehicleImagesComponent } from './vehicle-images/vehicle-images.component';
@NgModule({
  declarations: [
    RegistrationComponent,
    WebcamSnapshotComponent,
    EmploymentFormComponent,
    PreferencesComponent,
    ProfilePictureComponent,
    PersonalInformationComponent,
    DriveTestComponent,
    MedicalExaminationComponent,
    InsuranceComponent,
    ResumeComponent,
    ResidenceHistoryComponent,
    ProfileLicenseInformationComponent,
    TrafficConvictionsComponent,
    AccidentRecordsComponent,
    AccidentRecordViewComponent,
    AccidentRecordsComponent,
    AdditionalDocumentsComponent,
    AdditionalDocumentViewComponent,
    OnDutyHourComponent,
    EmploymentHistoryFormEmployedComponent,
    EmploymentHistoryFormUnemployedComponent,
    RequirementsCompleteActionComponent,
    IncorporationComponent,
    AdditionalDocumentUploadComponent,
    ResidenceHistoryFormComponent,
    PersonalInformationNewComponent,
    DriverTrainingCertificatesComponent,
    VehicleImagesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    /* WebcamModule, */
    NgxsModule.forFeature([RegistrationState, RegistrationRouterState, EmploymentState, ResidenceState]),
    ImageCropperComponent,
    ProfileModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDividerModule,
    MatExpansionModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    CompletionMeterModule,
    PhoneMaskDirective,
    LoadingGifComponent,
    ActionsModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    NgxSkeletonLoaderModule.forRoot(),
    ComponentsModule,
    CustomFormValidatorsModule,
    MatIconModule,
    SharedModule
  ],
  providers: [KYCVerificationService, RegistrationService, DriverApiService, DatePipe, CommonService]
})
export class RegistrationModule { }

export { RegistrationComponent } from './registration/registration.component';

